var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-book","titulo":"DESPESAS","subTitulo":"FINALIZAÇÃO"},nativeOn:{"click":function($event){return _vm.$router.push({ name: 'DespesasGerais_Finalizacao_Despesas' })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }